import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const HeaderPage = ({ progreso = 0 }) => {
  const { cotizacion } = useSelector((state: any) => state.Cotizacion);
  return (
    <div className="row justify-content-center">
      <div className="header__container col-11 col-md-7 col-lg-6 text-center mt-4">
        <h5 className="header__producto__nombre font-weight-bold">
          {cotizacion?.producto?.nombre}
        </h5>
        <p className="header__producto__descripcion">
          {cotizacion?.producto?.descripcion}
        </p>
        <ProgressBar
          className="header__progressbar"
          now={progreso}
          style={{ height: '3px' }}
        />
      </div>
    </div>
  );
};

export default HeaderPage;
